<template>

	<!-- content -->
	<div id="content" class="container">
		<div class="learning-title">
			<div class="inner">
				<div class="thumb-box" v-if="eduMain.thumbnail != null && eduMain.thumbnail !== ''" :style="'background-image: url(' + eduMain.thumbnail + ');'"></div>
				<div class="thumb-box" v-else style="background-image:url(/ssflex/assets/img/common/img_thumb.svg);" ></div>
				<div class="text-box">
					<div class="cate bedge-line">
						<span class="prim" v-if="!$options.filters.isEmpty(eduMain.cateCodeVO)">{{ eduMain.cateCodeVO.codeName }}</span>
						<span class="sec" v-if="eduMain.isMajor">주요</span>
					</div>
<!--					<h3 class="tit" v-html="eduMain.eduTitle"></h3>-->
					<h3 class="tit">
						{{ eduMain.shortTitle }} <span v-html="eduMain.eduTitle"></span>
					</h3>
					<div class="info">
						<div class="info-row" v-if="!$options.filters.isEmpty(eduMain.startDate) || !$options.filters.isEmpty(eduMain.endDate)">
							<strong>학습기간</strong>
							<div>{{ eduMain.startDate | scheduleFilter }} - {{ eduMain.endDate | scheduleFilter }}</div>
						</div>
						<div class="info-row">
							<strong>필수이수시간</strong>
							<div>{{ eduMain.playMinutes }}분</div>
						</div>
						<div class="info-row">
							<strong>수료기준</strong>
							<div>
								{{ completeText.join(", ") }}
								<!--<template v-for="(content, i) in eduMain.contentList">
									<template v-if="content.contentType === 'mov' ">
										동영상 재생완료<br>
									</template>
									<template v-if="content.contentType === 'file' ">
										파일 다운로드<br>
									</template>
									<template v-if="content.contentType === 'tst' ">
										테스트 필수<br>
									</template>
								</template>-->

							</div>
						</div>

						<!-- 교육 진행중 -->
						<div class="info-row info-progress" v-if="eduStudent != null && eduStudent.isRequest">
							<strong>학습진행율</strong>
							<div>
								<em :style="'width:' + ( $options.filters.avg( completeContentCnt, allContentCnt )) + '%;'">
									<span>{{ completeContentCnt | avg( allContentCnt ) }}%</span>
								</em>
							</div>
						</div>

					</div>
				</div>

				<!-- 교육 진행중 -->
				<div class="status-wrap" v-if="eduStudent != null && eduStudent.isRequest">
					<table class="learning-status">
						<caption class="blind">학습 현황표</caption>
						<colgroup>
							<col style="width: 20%;">
							<col style="width: 50%;">
							<col style="width: 30%;">
						</colgroup>
						<thead>
						<tr>
							<th scope="col">구분</th>
							<th scope="col">학습내용</th>
							<th scope="col">학습현황</th>
						</tr>
						</thead>
						<tbody>
						<tr v-for="(content, i) in eduMain.contentList">
							<template v-if="content.contentType === 'mov'" >
								<td>영상</td>
								<td>
									<template v-if="content.qstMovVO != null">
										{{content.qstMovVO.movTitle}}
									</template>
								</td>
								<td>
										<span>
											<template v-if="answerList[i] != null">
												{{ Math.floor(answerList[i].ansMovVO.currentTimes / 60) }}분
											</template>
											<template v-else>
												0분
											</template>
										</span>
									/ {{content.qstMovVO.playMinutes}}분
								</td>
							</template>
							<template v-else-if="content.contentType === 'file'" >
								<td>파일</td>
								<td>{{content.qstFileVO.fileDesc}}</td>
								<td>
										<span>
											<template v-if="answerList[i] != null">
												{{ answerList[i].fileDownloadCount }}
											</template>
											<template v-else>
												0
											</template>
										</span>
									/ {{content.qstFileVO.fileList.length}}개
								</td>
							</template>
							<template v-else-if="content.contentType === 'tst'" >
								<td>테스트</td>
								<td>{{ content.qstTstList.length }}문항</td>
								<td>
										<span>
											<template v-if="answerList[i] != null">
												{{ answerList[i].tstSolveCount }}
											</template>
											<template v-else>
												0
											</template>
										</span>
									/ {{content.qstTstList.length}}문항
								</td>
							</template>
							<template v-else-if="content.contentType === 'wait'" >
								<td>미정</td>
								<td>준비중</td>
								<td></td>
							</template>
						</tr>
						</tbody>
					</table>
				</div>

				<!-- 교육 신청전 + 비로그인 -->
				<div class="btn-wrap" v-if=" eduStudent == null || !eduStudent.isRequest">
					<template v-if="eduMain.numLeft > 0">
						<a href="javascript:;" class="btn-apply" @click="doRequest" v-if="finishCount < eduMain.numLeft"><span>교육신청</span></a>
						<a href="javascript:;" class="btn-apply" v-if="finishCount >= eduMain.numLeft"><span>선착순 마감</span></a>
					</template>
					<template v-else-if="!eduMain.isDisplay || !this.isExpiryDate  ">
						<div class="comment-info m-b-10">
							<i class="ico-info" ></i>
							<p v-if="!eduMain.isDisplay">공개되지 않은 교육입니다.</p><p v-if="!this.isExpiryDate">교육 신청 기간이 아닙니다. </p>
						</div>
					</template>
					<template v-else>
						<a href="javascript:;" class="btn-apply" @click="doRequest"><span>교육신청</span></a>
					</template>

					<a href="javascript:;" class="btn-like" :id="'eduWish-' + eduMain.emIdx" :data-emIdx="eduMain.emIdx" @click="setWish"><i class="ico-heart"></i>{{ eduMain.wishCount }}</a>
					<!--					<a href="#" class="btn-apply" data-toggle="modal" data-target="#learning">신청하기</a>
										<a href="#" class="btn-like"><i class="ico-heart"></i>50</a>-->
				</div>

				<!-- 교육 진행중 -->
				<div class="btn-wrap" v-else-if="eduStudent != null && eduStudent.isRequest">
					<template v-if="!eduMain.isDisplay">
						<div class="comment-info m-b-10">
							<i class="ico-info" ></i>
							<p>비공개된 교육입니다. 자세한 내용은 고객센터로 문의바랍니다.</p>
						</div>
					</template>
					<template v-else-if="!eduStudent.isComplete && !isEnableComplete ">
						<a href="javascript:;" class="btn-apply" v-if="completeContentCnt <= 0" @click="doAnswer(eduMain.emIdx);">학습 시작하기</a>
						<a href="javascript:;" class="btn-apply" v-if="completeContentCnt > 0" @click="doAnswer(eduMain.emIdx);">학습 계속하기</a>
					</template>
					<template v-else-if="!eduStudent.isComplete && isEnableComplete ">
						<a href="javascript:;" class="btn-apply" @click="doComplete">이수 완료</a>
					</template>

					<a href="javascript:;" class="btn-like" :id="'eduWish-' + eduMain.emIdx" :data-emIdx="eduMain.emIdx" @click="setWish"><i class="ico-heart"></i>{{ eduMain.wishCount }}</a>
				</div>


			</div>
		</div>

		<edu-before v-if="eduStudent == null || !eduMain.isDisplay" v-bind:eduMain="eduMain"></edu-before>

		<template v-else-if="eduStudent != null && eduStudent.isRequest ">
			<div class="learning-content">
				<div class="inner">
					<dl>
						<dt>개요</dt>
						<dd v-html="eduMain.introduce"></dd>
					</dl>
					<dl>
						<dt>목표</dt>
						<dd v-html="eduMain.goal"></dd>
					</dl>
					<dl>
						<dt>강사</dt>
						<dd>
							{{ eduMain.teachName }}
						</dd>
					</dl>

					<dl>
						<dt>교육 과정</dt>
						<dd>
							<ul class="learning-list">


								<!-- 단계별 진행 -->
								<template v-if="eduMain.isStep">
									<li v-for="(content, i) in eduMain.contentList" >
										<template v-if="content.contentType === 'mov'" >
											<span v-if="content.qstMovVO != null">{{ content.qstMovVO.movTitle }}</span>
											<a href="javascript:;" class="btn btn-sm btn-gray" v-if="eduStudent != null && answerList[i] != null && !answerList[i].isComplete"  @click="doAnswer( content.emIdx, i)">동영상 재생</a>
											<a href="javascript:;" class="btn btn-sm btn-gray" v-else-if="answerList[i] != null && answerList[i].isComplete"  @click="doReplay( content.emIdx, i)">다시보기</a>
										</template>
										<template v-else-if="content.contentType === 'file'" >
											<span>{{ content.qstFileVO.fileDesc }}</span>
											<a href="javascript:;" class="btn btn-sm btn-gray" v-if="eduStudent != null && answerList[i] != null && answerList[i].isComplete"  @click="doReplay( content.emIdx, i)">다운로드</a>
										</template>
										<template v-else-if="content.contentType === 'tst'" >
											<span class="subject">{{content.qstTstList.length}}문항</span>
											<template v-if="eduStudent != null && answerList[i] != null && answerList[i].isComplete" >
												<a href="javascript:;" class="btn btn-sm btn-gray" @click="doRestart( content.emIdx, i, answerList[i])">재시험</a>
												<span>(정답율 : {{answerList[i].tstCorrectCount | avg(answerList[i].tstSolveCount) }}%)</span>
											</template>
										</template>
										<template v-else-if="content.contentType === 'wait'" >
											<span class="subject">준비중</span>
										</template>
									</li>
								</template>
								<!-- 임의 진행 -->
								<template v-else>
									<li v-for="(content, i) in eduMain.contentList" >
										<template v-if="content.contentType === 'mov'" >
											<span v-if="content.qstMovVO != null">{{ content.qstMovVO.movTitle }}</span>
											<a href="javascript:;" class="btn btn-sm btn-gray" v-if="eduStudent != null && answerList[i] != null && !answerList[i].isComplete" @click="doAnswer( content.emIdx, i, answerList[i])">동영상 재생</a>
											<a href="javascript:;" class="btn btn-sm btn-gray" v-else-if="eduStudent != null && answerList[i] != null && answerList[i].isComplete" @click="doReplay( content.emIdx, i, answerList[i])">다시보기</a>
										</template>
										<template v-else-if="content.contentType === 'file'" >
											<span>{{ content.qstFileVO.fileDesc }}</span>
											<template v-if="eduMain.isDisplay && isExpiryDate">
												<a href="javascript:;" class="btn btn-sm btn-gray" v-if="eduStudent != null && answerList[i] != null && !answerList[i].isComplete" @click="doAnswer( content.emIdx, i, answerList[i])">다운로드</a>
												<a href="javascript:;" class="btn btn-sm btn-gray" v-else-if="eduStudent != null && answerList[i] != null && answerList[i].isComplete" @click="doReplay( content.emIdx, i, answerList[i])">다운로드</a>
											</template>
										</template>
										<template v-else-if="content.contentType === 'tst'" >
											<span class="subject">{{content.qstTstList.length}}문항</span>
											<template v-if="eduStudent != null">
												<a href="javascript:;" class="btn btn-sm btn-gray" @click="doAnswer( content.emIdx, i)">테스트</a>
											</template>
											<template v-if="eduStudent != null && answerList[i] != null && answerList[i].isComplete" >
												<a href="javascript:;" class="btn btn-sm btn-gray" @click="doRestart( content.emIdx, i, answerList[i])">재시험</a>
												<span>(정답율 : {{answerList[i].tstCorrectCount | avg(answerList[i].tstSolveCount) }}%)</span>
											</template>
										</template>
										<template v-else-if="content.contentType === 'wait'" >
											<span class="subject">준비중</span>
										</template>
									</li>
								</template>

								<!--<li>
									<span>유형히어로즈 소개</span>
									<a href="#" class="btn btn-sm btn-gray">다시보기</a>
								</li>
								<li>
									<span>유형히어로즈 학습시연</span>
									<a href="#" class="btn btn-sm btn-gray">다시보기</a>
								</li>
								<li>
									<span>테스트 10문항</span>
									<a href="#" class="btn btn-sm btn-gray">다시보기</a>
								</li>-->
							</ul>
						</dd>
					</dl>

				</div>
			</div>
		</template>



		<!-- learning modal -->
		<div class="modal fade" id="learning" tabindex="-1">
			<div class="modal-dialog modal-dialog-centered modal-lg">
				<div class="modal-content">
					<div class="modal-header">
						<h4>건축·건설 실무자를 위한 Lumion 100배 활용하기</h4>
						<button type="button" class="btn-close" data-dismiss="modal" aria-label="Close"><span class="blind">닫기</span></button>
					</div>
					<div class="modal-body">
						<div class="video-wrap">
							<iframe width="560" height="315" src="https://www.youtube.com/embed/V3UB54eA2S4" frameborder="0" allowfullscreen></iframe>
						</div>
					</div>
					<div class="modal-footer">
						<div class="play-controls">
							<button class="btn-slow" type="button"><span class="blind">느리게</span></button>
							<input class="inp-faster" type="text" name="faster" value="x1" >
							<button class="btn-fast" type="button"><span class="blind">빠르게</span></button>
						</div>
						<div class="play-start">
							<button class="btn-fast" type="button"><i class="play"></i>재생</button>
							<!--<button class="btn-fast" type="button"><i class="pause"></i>일시정지</button>-->
						</div>
					</div>
				</div>
			</div>
		</div>
		<!-- //learning modal -->
		<div class="btn-area">
			<a href="javascript:;" class="btn-listgo" @click="goBackList">목록으로</a>
		</div>
	</div>

</template>

<script>
import Qs from "qs";
import eduBefore from "@/components/educations/main/eduBefore";
export default {
	name: "eduLearning",
	components: {eduBefore},
	prop: {
		emIdx: Number,
	},
	data() {

		const userId = this.getLoginId()

		return {

			userId,

			emIdx: this.$route.query.emIdx,
			eduMain: new this.EduMainVO(),
			eduContentList: new Array(new this.EduContentVO()),
			eduStudent: new this.EduStudentVO(),
			answerList: new Array( new this.EduAnswerVO() ),


			// 전체 컨텐츠 수, 이수한 컨텐츠 수
			allContentCnt: 0,
			completeContentCnt: 0,

			// 완료처리 가능여부
			isEnableComplete: true,

			// 현재 신청 + 완료자 수
			finishCount: 0,

			// 수료기준 텍스트
			completeText: [],
			//기간이 유효한지
			isExpiryDate : true,
		}
	},
	created() {

		this.getEduMain( this.emIdx, this.userId );

		window.eduView = this
	},
	mounted() {

		//this.getWishLike( this.emIdx, this.userId );

	},
	updated() {

		this.$nextTick(() => {
			this.getWishLike( this.emIdx, this.userId );
		})
	},
	methods: {


		getStudent: function ( emIdx, userId ) {

			var self = this;
			self.completeContentCnt = 0;

			self.$eventBus.$emit("startProgress", 1)
			this.axiosCaller.get(  this, this.APIs.EDU_STUDENT + "/", {
				emIdx: emIdx,
				userId: userId,
			}, function (res) {
				self.$eventBus.$emit("doneProgress", 1)

				const result = res.data
				//console.log(result)

				if ( result.status === "ok" ) {
					self.eduStudent = result.eduStudentVO;
					self.answerList = result.answerList;

					/**
					 * 사용자의 이수 컨텐츠 합
					 */
					var index = 0;
					self.answerList.forEach(ans => {

						if ( !ans.isComplete ) {
							self.isEnableComplete = false
						}

						if ( ans.contentType === 'tst' ) {
							self.completeContentCnt += ans.tstSolveCount;
						} else if ( ans.contentType === 'mov' ) {

							if ( ans.isComplete || Math.floor(ans.ansMovVO.currentTimes / 60) >= self.eduMain.contentList[index].qstMovVO.playMinutes ) {
								/**
								 * 영상이수완료 or 플레이시간이 필수플레이 시간보다 많을 경우
								 */
								self.completeContentCnt += self.eduMain.contentList[index].qstMovVO.playMinutes
							} else {
								/**
								 * 플레이 시간을 분단위로 추가
								 * @type {number}
								 */
								self.completeContentCnt += Math.floor(ans.ansMovVO.currentTimes / 60);
							}
						} else if ( ans.contentType === 'file' ) {
							if ( ans.isComplete ) {
								self.completeContentCnt += self.eduMain.contentList[index].qstFileVO.fileList.length;
							} else {
								self.completeContentCnt += ans.fileDownloadCount;
							}
						}
						index++;
					})

					//console.log("self.completeContentCnt ::::: " + self.completeContentCnt);
				} else {
					console.log(result.msg)
				}
				self.$eventBus.$emit("doneProgress", 2)
			})

		},


		getEduMain: function (_emIdx, _userId) {

			var self = this

			self.$eventBus.$emit("startProgress")
			this.axiosCaller.get(this, this.APIs.EDU_MAIN + "/getEduMain", {
				emIdx : _emIdx,
				userId : _userId,
			}, function (res) {
				self.$eventBus.$emit("doneProgress")

				const result = res.data
				console.log(result)
				if ( result.status === "ok" ) {

					self.eduMain = result.eduMain

					// 현재 신청자 + 완료자 합계산
					self.finishCount = self.eduMain.requestCount + self.eduMain.completeCount;

					self.eduMain.playMinutes = 0;
					self.allContentCnt = 0;

					self.completeText = []
					self.eduMain.contentList.forEach(cv => {

						// 교육 컨텐츠의 개수 합 + 기타 표출용 텍스트 정의
						if ( cv.contentType === 'tst' ) {

							self.eduMain.isTest = true;
							self.eduMain.isTestTxt = "있음";
							self.allContentCnt += cv.qstTstList.length;

							// 수료기준 : 문제풀이
							if (self.completeText.indexOf("문제풀이") < 0) {
								self.completeText.push( "문제풀이" );
							}

						} else if ( cv.contentType === 'mov' ) {

							if(cv.qstMovVO == null){
								alert("교육 구성이 진행중입니다.")
								history.back();
								return
							}

							self.eduMain.playMinutes += cv.qstMovVO.playMinutes;
							self.allContentCnt += cv.qstMovVO.playMinutes;

							// 수료기준 : 동영상 재생완료
							if (self.completeText.indexOf("동영상 재생") < 0) {
								self.completeText.push( "동영상 재생" );
							}

						} else if ( cv.contentType === 'file' ) {

							if(cv.qstFileVO == null){
								history.back();
								return
							}

							self.allContentCnt += cv.qstFileVO.fileList.length;

							// 수료기준 : 자료 내려받기
							if (self.completeText.indexOf("자료 내려받기") < 0) {
								self.completeText.push( "자료 내려받기" );
							}

						} else if ( cv.contentType === 'wait' ) {

							self.allContentCnt += 1;

							// 준비중 컨텐츠 포함
							if (self.completeText.indexOf("준비중") < 0) {
								self.completeText.push( "준비중" );
							}
						}

						self.eduMain.introduce = self.$options.filters.nl2br(self.eduMain.introduce);
						self.eduMain.goal = self.$options.filters.nl2br(self.eduMain.goal);

						// 교육항목 저장
						self.eduContentList = self.eduMain.contentList

						// self.fadeIn('.__pop.createResult')

						// 현재 교육 관심, 좋아요 조회
						//self.getWishLike( self.emIdx, self.userId );

					})

					self.getStudent( self.emIdx, self.userId );

					/*기간 내 유효한 교육인지 확인 */
					let getDateIs = new Date()
					var nowDateIs = new Date(getDateIs.getFullYear() +"-"+(getDateIs.getMonth()+1) +"-"+ getDateIs.getDate())

					if(self.eduMain.startDate != null && self.eduMain.startDate !== "" ){
						var startDateIs = new Date(self.$options.filters.scheduleFilter( self.eduMain.startDate))
						if(startDateIs > nowDateIs ){
							self.isExpiryDate = false
						}
					}
					if(self.eduMain.endDate != null && self.eduMain.endDate !== "" ){
						var endDateIs = new Date(self.$options.filters.scheduleFilter( self.eduMain.endDate))
						if( nowDateIs > endDateIs ){
							self.isExpiryDate = false
						}
					}
				}

				//console.log("allContentCnt ::::: " + self.allContentCnt)
			})

		},


		async doRequest () {

			if ( !await this.requireLogin(this) ) {
				return
			}


			this.swalUtils.fire(this.eduMain.eduTitle, "교육을 이수시작하시겠습니까?", "info", true )
					.then( (result) => {

						if ( result.isConfirmed ) {

							var self = this
							self.$eventBus.$emit("startProgress", 2)
							this.axiosCaller.put(this, this.APIs.EDU_STUDENT + "/request", {
								emIdx: this.eduMain.emIdx,
								userId: this.getLoginId(),
							}, function (res) {
								self.$eventBus.$emit("doneProgress", 2)

								const result = res.data
								//console.log(result)

								self.$eventBus.$emit("doneProgress")
								if ( result.status === "ok" ) {
									self.swalUtils.gritter( self.eduMain.eduTitle, "교육 이수 시작합니다.", "info", 1500 )
											.then(() => {
												location.reload()
											})
									/*alert( "교육 이수 시작합니다." );
									location.reload()*/
								} else {

									if ( result.msg === "no_target" ) {
										self.swalUtils.gritter( "공개교육이 아닙니다.", "죄송합니다. 교육대상이 아닙니다.", "info", 1500 )
										return;
									}
								}
							})

						}
					})

		},


		/**
		 * 학습 시작하기
		 * @param emIdx
		 * @param step
		 */
		doAnswer (emIdx, step = null) {

			let url = this.APIs.FRONT_URL + "/learning/proceed/" + emIdx + "/" + btoa(this.getLoginId()) + "/";
			if ( step != null ) {
				url += "?playStep=" + step;
			}

			const temp = {
				url: url,
				target: "proceed",
				isCloseBTN: "Y",
			}

			this.appOpen( temp );
		},


		/**
		 * 다시보기
		 * @param emIdx
		 * @param index
		 */
		doReplay: function (emIdx, step) {

			let url = this.APIs.FRONT_URL + "/learning/proceed/" + emIdx + "/" + btoa(this.getLoginId()) + "/?isReplay=true&playStep=" + step;

			const temp = {
				url: url,
				target: "proceed",
				isCloseBTN: "Y",
			}
			this.appOpen( temp );
		},


		/**
		 * 교육 재시작
		 * @param emIdx
		 * @param step
		 * @param _answerVO
		 */
		doRestart (emIdx, step = null, _answerVO = null) {

			const self = this

			/**
			 * 답변데이터가 있을 경우 삭제후 재시작 여부 확인
			 */
			if ( _answerVO != null && _answerVO.isComplete ) {

				self.swalUtils.fire("교육 재시작", "교육 이수기록을 삭제하고 다시 시작하시겠습니까?", "warning",true)
						.then((confirm) => {

							if ( confirm.isConfirmed ) {
								self.axiosCaller.delete(self, self.APIs.EDU_ANSWER + "/" + _answerVO.ecIdx + "/" + _answerVO.userId, {},(res) => {

									const result = res.data;
									if ( result.status === true ) {
										self.doAnswer(emIdx, step)
									} else {
										self.swalUtils.gritter(result.status, result.msg, "error")
									}
								})
							}
						})
			}
		},



		/**
		 * 수동 학습완료 처리
		 */
		doComplete: function () {

			const self = this

			/**
			 * 준비중인 컨텐츠가 있을 경우 안내후 닫기
			 */
			if ( self.eduMain.contentList.length > self.answerList.length ) {

				self.swalUtils.gritter( "다음 강의는 준비중입니다.", "다음 강의는 준비중입니다. <br />다음 강의 오픈시 알려드리겠습니다.", "info" )
				return;
			}

			self.$eventBus.$emit("startProgress", 2)
			this.axiosCaller.put(this, this.APIs.EDU_STUDENT + "/complete", {
				emIdx: this.eduMain.emIdx,
				userId: this.getLoginId(),
			}, function (result) {
				self.$eventBus.$emit("doneProgress", 2)

				self.swalUtils.gritter( "교육완료", "교육 이수가 완료되었습니다.", "info")
						.then(() => {
							location.reload()
						})
			})

		},


		goBackList(e) {
			this.$emit("goList");
			// history.back();
		},


		/**
		 * 좋아요, 찜하기 조회
		 * @param _emIdx
		 * @param _userId
		 */
		getWishLike ( _emIdx, _userId ) {

			const self = this
			self.$eventBus.$emit("startProgress", 2)
			this.axiosCaller.get( this, this.APIs.EDU_MINE + "/getWishLike", {
				emIdx: _emIdx,
				userId: _userId,
			}, function (res) {
				self.$eventBus.$emit("doneProgress", 2)

				const result = res.data;
				console.log("== getWishLike ==")
				console.log(result)

				if ( result.status === "ok" ) {

					// 상세에서 사용
					if ( result.wishVO !== null ) {
						document.querySelector('#eduWish-' + result.wishVO.emIdx).classList.add("active");
						//$('#eduWish-' + result.wishVO.emIdx).addClass("active");
					}
					if ( result.likeVO !== null ) {
						document.querySelector('#eduLike-' + result.likeVO.emIdx).classList.add("active");
						//$('#eduLike-' + result.likeVO.emIdx).addClass("active");
					}

					// 목록에서 사용
					if ( result.wishList !== null ) {
						result.wishList.forEach(wish => {
							$('#eduWish-' + wish.emIdx).addClass("active");
						})
					}
					if ( result.likeList !== null ) {
						result.likeList.forEach(like => {
							$('#eduLike-' + like.emIdx).addClass("active");
						})
					}

				} else {
					console.log(result.msg)
				}

			})

		},



		async setLike (e) {

			if ( await this.requireLogin(this) ) {

				var emIdx = this.emIdx;
				var userId = this.getLoginId();

				if ( !e.target.classList.contains("active") ) {
					this.putLike( emIdx, userId );
					e.target.classList.add("active");
					this.swalUtils.gritter( "추천", "추천 되었습니다.", "info", 800 )
				} else {
					this.deleteLike( emIdx, userId );
					e.target.classList.remove("active");
					this.swalUtils.gritter( "추천", "추천 취소되었습니다.", "info", 800 )
				}
			}

		},

		// DONE : 찜, 좋아요 유틸 추가
		// DONE : tags : eduLike-' + eduMain.emIdx || eduWish-' + eduMain.emIdx
		async setWish (e) {

			if ( await this.requireLogin(this) ) {

				var emIdx = this.emIdx;
				var userId = this.getLoginId();

				if ( !e.target.classList.contains("active") ) {
					this.putWish( emIdx, userId );
					document.querySelector('#eduWish-' + emIdx).classList.add("active");
					this.swalUtils.gritter( "관심교육", "관심교육으로 등록되었습니다.", "info", 800 )
				} else {
					this.deleteWish( emIdx, userId );
					document.querySelector('#eduWish-' + emIdx).classList.remove("active");
					this.swalUtils.gritter( "관심교육", "관심교육이 해제되었습니다.", "info", 800 )
				}
			}

		},




		putWish: function ( _emIdx, _userId ) {

			const self = this
			self.$eventBus.$emit("startProgress", 3)
			this.axiosCaller.put( this, this.APIs.EDU_MINE + "/wish", {
				emIdx: _emIdx,
				userId: _userId
			}, function (res) {
				self.$eventBus.$emit("doneProgress", 3)

				const result = res.data;
				console.log("== putWish ==")
				console.log(result)
				self.getEduMain(_emIdx, _userId);
			})

		},

		deleteWish: function ( _emIdx, _userId ) {

			const self = this
			self.$eventBus.$emit("startProgress", 3)
			this.axiosCaller.delete( this, this.APIs.EDU_MINE + "/wish", {
				emIdx: _emIdx,
				userId: _userId
			}, function (res) {
				self.$eventBus.$emit("doneProgress", 3)

				const result = res.data;
				console.log("== deleteWish ==")
				console.log(result)
				self.getEduMain(_emIdx, _userId);
			})
		},


		putLike: function ( _emIdx, _userId ) {

			const self = this
			self.$eventBus.$emit("startProgress", 3)
			this.axiosCaller.put( this, this.APIs.EDU_MINE + "/like", {
				emIdx: _emIdx,
				userId: _userId
			}, function (res) {
				self.$eventBus.$emit("doneProgress", 3)

				const result = res.data;
				console.log("== putLike ==")
				console.log(result)
				self.getEduMain(_emIdx, _userId);
				//self.eduMain.likeCount = result.counts.likeCount
			})

		},


		deleteLike: function ( _emIdx, _userId ) {

			const self = this
			self.$eventBus.$emit("startProgress", 3)
			this.axiosCaller.delete( this, this.APIs.EDU_MINE + "/like", {
				emIdx: _emIdx,
				userId: _userId
			}, function (res) {
				self.$eventBus.$emit("doneProgress", 3)

				const result = res.data;
				console.log("== deleteLike ==")
				console.log(result)
				self.getEduMain(_emIdx, _userId);
				//self.eduMain.likeCount = result.counts.likeCount
			})

		},

	}
}
</script>

<style scoped>

</style>
